const isNatural = (n) => {
  if (typeof n !== 'number') return false;

  return n >= 0.0 && Math.floor(n) === n && n !== Infinity;
};

export default isNatural;
